import React from 'react';
import BarkerProducciones from './BarkerProducciones';

function App() {
  return (
    <div className="App">
      <BarkerProducciones />
    </div>
  );
}

export default App;
